import BaseService from "./Base.Service";

class DeclarationsService extends BaseService {
	constructor() {
		super("declarations");
	}

    async getCompanyGraphData() {
        try {
            const {data} = await this.conn.axios.get(`/declarations/company-graph`);
            return data;
        } catch (err) {
            return this.sendError("Erros foram encontrados ao recuperar dados", false, err);
        }
    }
}

export default DeclarationsService;
